(function () {
  const doc = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // New Glory Motion Settings
  const SPEEDS = {
    super_slow: { duration: 1200, step: 260 },
    slow: { duration: 980, step: 210 },
    normal: { duration: 780, step: 150 },
    fast: { duration: 520, step: 95 },
    super_fast: { duration: 360, step: 60 }
  };

  const HOVER_SPEEDS = {
    super_slow: 420,
    slow: 340,
    normal: 260,
    fast: 190,
    super_fast: 130
  };

  const TYPES = {
    fade_up: { x: '0px', y: '24px', scale: '1' },
    fade_in: { x: '0px', y: '0px', scale: '1' },
    slide_left: { x: '24px', y: '0px', scale: '1' },
    slide_right: { x: '-24px', y: '0px', scale: '1' },
    soft_zoom: { x: '0px', y: '10px', scale: '0.975' }
  };

  const revealSelector = [
    '[data-ng-reveal]',
    '.ng-home-card',
    '.ng-merch-product',
    '.ng-merch-all__intro',
    '.ng-merch-service',
    '.ng-merch-cta',
    '.ng-related-product',
    '.ng-partner-card',
    '.ng-partners__cta',
    '.ng-product-note',
    '.ng-product-event-cta',
    '.ng-story-image-card',
    '.ng-story-step',
    '.ng-story-cta',
    '.ng-community-hub__intro',
    '.ng-community-hub__story',
    '.ng-community-hub__card',
    '.ng-community-hub__subtle-info',
    '.ng-community-hub__cta',
    '.ng-contact__intro',
    '.ng-contact__form',
    '.ng-custom-cart__inner',
    '.ng-events-page__footer-cta',
    '.ng-footer-signup__inner',
    '.ng-product-media',
    '.ng-product-info'
  ].join(', ');

  const supportsSessionStorage = (function () {
    try {
      sessionStorage.setItem('ng-storage-test', '1');
      sessionStorage.removeItem('ng-storage-test');
      return true;
    } catch (error) {
      return false;
    }
  })();

  function markPageReady() {
    requestAnimationFrame(function () {
      doc.classList.add('ng-page-ready');
    });
  }

  function finishPreloader() {
    doc.classList.add('ng-preloader-done');

    if (supportsSessionStorage) {
      sessionStorage.setItem('ng-preloader-seen', '1');
    }
  }

  function initPreloader() {
    const preloader = document.querySelector('[data-ng-preloader]');
    const alreadySeen = doc.classList.contains('ng-preloader-seen');

    if (!preloader || alreadySeen || reducedMotion) {
      doc.classList.add('ng-preloader-seen', 'ng-preloader-done');
      markPageReady();
      return;
    }

    markPageReady();

    window.addEventListener(
      'load',
      function () {
        window.setTimeout(finishPreloader, 980);
      },
      { once: true }
    );

    window.setTimeout(finishPreloader, 1800);
  }

  function shouldAnimateLink(link, event) {
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download') || link.hasAttribute('data-no-page-transition')) return false;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return false;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;

    return true;
  }

  function initPageTransitions() {
    document.addEventListener('click', function (event) {
      const link = event.target.closest('a[href]');
      if (!shouldAnimateLink(link, event)) return;

      event.preventDefault();
      doc.classList.add('ng-page-leaving');

      window.setTimeout(function () {
        window.location.href = link.href;
      }, 260);
    });
  }

  function initTopbarScroll() {
    function update() {
      doc.classList.toggle('ng-topbar-scrolled', window.scrollY > 18);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function getSpeed(value, fallback) {
    return SPEEDS[value] || SPEEDS[fallback] || SPEEDS.normal;
  }

  function getType(value) {
    return TYPES[value] || TYPES.fade_up;
  }

  function getRevealGroup(item) {
    if (item.dataset.ngReveal) return item.dataset.ngReveal;
    if (item.classList.contains('ng-merch-product')) return 'product';
    if (item.classList.contains('ng-related-product')) return 'product';
    if (item.classList.contains('ng-product-note')) return 'card';
    if (item.classList.contains('ng-product-event-cta')) return 'cta';
    if (item.classList.contains('ng-product-media')) return 'image';
    if (item.classList.contains('ng-product-info')) return 'details';
    if (item.classList.contains('ng-partner-card')) return 'card';
    if (item.classList.contains('ng-home-card')) return 'card';
    if (item.classList.contains('ng-story-image-card')) return 'image';
    if (item.classList.contains('ng-story-cta')) return 'cta';
    if (item.classList.contains('ng-contact__form')) return 'form';
    return 'intro';
  }

  function getMotionRoot(item) {
    return item.closest('[data-ng-motion-root]');
  }

  function motionEnabled(root) {
    return !root || root.dataset.ngMotionEnabled !== 'false';
  }

  function getTypeForGroup(root, group) {
    if (!root) return getType('fade_up');

    if (group === 'intro') return getType(root.dataset.ngIntroAnimation || root.dataset.ngCardAnimation || 'fade_up');
    if (group === 'image') return getType(root.dataset.ngImageAnimation || root.dataset.ngCardAnimation || 'fade_up');
    if (group === 'product') return getType(root.dataset.ngProductAnimation || root.dataset.ngCardAnimation || 'fade_up');
    if (group === 'details') return getType(root.dataset.ngDetailsAnimation || root.dataset.ngCardAnimation || 'fade_up');
    if (group === 'form') return getType(root.dataset.ngFormAnimation || root.dataset.ngDetailsAnimation || root.dataset.ngCardAnimation || 'fade_up');
    if (group === 'cta') return getType(root.dataset.ngCtaAnimation || root.dataset.ngCardAnimation || 'fade_up');

    return getType(root.dataset.ngCardAnimation || 'fade_up');
  }

  function getSpeedForGroup(root, group) {
    if (!root) return getSpeed('normal');

    if (group === 'intro') return getSpeed(root.dataset.ngIntroSpeed || root.dataset.ngCardSpeed || 'normal');
    if (group === 'image') return getSpeed(root.dataset.ngImageSpeed || root.dataset.ngCardSpeed || 'normal');
    if (group === 'product') return getSpeed(root.dataset.ngProductSpeed || root.dataset.ngCardSpeed || 'normal');
    if (group === 'details') return getSpeed(root.dataset.ngDetailsSpeed || root.dataset.ngCardSpeed || 'normal');
    if (group === 'form') return getSpeed(root.dataset.ngFormSpeed || root.dataset.ngDetailsSpeed || root.dataset.ngCardSpeed || 'normal');
    if (group === 'cta') return getSpeed(root.dataset.ngCtaSpeed || root.dataset.ngCardSpeed || 'normal');

    return getSpeed(root.dataset.ngCardSpeed || 'normal');
  }

  function setupMotionRoot(root) {
    if (!root) return;

    const hoverDuration = HOVER_SPEEDS[root.dataset.ngHoverSpeed] || HOVER_SPEEDS.normal;
    const switchDuration = getSpeed(root.dataset.ngSwitchSpeed || 'fast', 'fast').duration;

    root.style.setProperty('--ng-hover-duration', `${hoverDuration}ms`);
    root.style.setProperty('--ng-section-switch-duration', `${switchDuration}ms`);
  }

  function prepareRevealItem(item, index) {
    const root = getMotionRoot(item);

    setupMotionRoot(root);
    item.classList.add('ng-reveal-item');

    if (reducedMotion || !motionEnabled(root)) {
      item.classList.add('is-visible');
      item.style.removeProperty('--ng-reveal-delay');
      return false;
    }

    const group = getRevealGroup(item);
    const type = getTypeForGroup(root, group);
    const speed = getSpeedForGroup(root, group);
    const sequence = getSpeed(root ? root.dataset.ngSequenceSpeed : 'normal', 'normal');
    const order = Number(item.dataset.ngOrder || index);
    const delay = Math.min(Math.max(order, 0) * sequence.step, 1100);

    item.style.setProperty('--ng-reveal-x', type.x);
    item.style.setProperty('--ng-reveal-y', type.y);
    item.style.setProperty('--ng-reveal-scale', type.scale);
    item.style.setProperty('--ng-reveal-duration', `${speed.duration}ms`);
    item.style.setProperty('--ng-reveal-delay', `${delay}ms`);

    return true;
  }

  function initRevealItems(root) {
    const scope = root || document;
    const items = Array.from(scope.querySelectorAll(revealSelector));

    if (scope.matches && scope.matches(revealSelector)) {
      items.unshift(scope);
    }

    const uniqueItems = Array.from(new Set(items));
    const activeItems = uniqueItems.filter(prepareRevealItem);

    if (!activeItems.length) return;

    if (!('IntersectionObserver' in window)) {
      activeItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.16 }
    );

    activeItems.forEach(function (item) {
      if (item.classList.contains('is-visible')) return;
      observer.observe(item);
    });
  }

  function init() {
    initPreloader();
    initPageTransitions();
    initTopbarScroll();
    initRevealItems(document);
  }

  window.NGMotion = {
    refresh: function (root) {
      initRevealItems(root || document);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRevealItems(event.target);
  });
})();
